import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FuseSplashScreenService } from '@barebone-fuse/@fuse/services/splash-screen.service';
import { CommandService } from '@core/services/command.service';
import { PlatformQueryService } from '@core/services/platform-query.service';
import { Header } from '@features/spreadsheet/models/header';
import { PlatformCommand } from '@shared/commands/command-base';
import { IDialogView } from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';
import { Configuration } from '@shared/models/configuration';
import { DialogModel } from '@shared/models/dialog.model';
import { PlatformQuery } from '@shared/models/platform-query/platform-query';
import { DialogService } from '@shared/services/dialog-service';
import { take } from 'rxjs/operators';
import { TableHitTestResult } from 'yfiles';
import { FlexSheetService } from '@features/spreadsheet/services/flex-sheet.service';
import {Api} from '@shared/constants/common-field.constants';

@Component({
    standalone: false,
    selector: 'app-create-questionnaire-from-excel-dialog',
  templateUrl: './create-questionnaire-from-excel-dialog.component.html',
  styleUrls: ['./create-questionnaire-from-excel-dialog.component.scss']
})
export class CreateQuestionnaireFromExcelDialogComponent implements OnInit, IDialogView  {
  inputForm: FormGroup;
  isValid = true;
  headers: Header[] = [];
  workbookSetId: string;
  workbookId: string;
  worksheetId: string;
  api = 'SpreadsheetApi';
  sourceType = 'ExcelTableDefinition';
  invalidateSubject = new InvalidateSubject();
  showGrid = false;
  customTypes: any[];
  workbookName: string;
  worksheetName: string;
  questionnaireName: string;
  totalRowArray: number[];
  parameters = null;
  private tableId: any;
  private onSelectionAllChangedInvoked = false;

  constructor(private formBuilder: FormBuilder,
    private fuseSplashScreenService: FuseSplashScreenService,
    private platformQueryService: PlatformQueryService,
    private commandService: CommandService,
    private flexSheetService: FlexSheetService,
    public dialogService: DialogService) {
    this.inputForm = this.formBuilder.group({
      questionnaireName: ['', Validators.required],
      headerRow: ['1', Validators.required],
      startColumn: ['', Validators.required],
      endColumn: ['', Validators.required],
      startDataRow: [''],
      endDataRow: [''],
    });

    this.isValid = true;
    this.inputForm.valueChanges.subscribe(formValue => {
      this.isValid = this.inputForm.valid;
      this.data.isDisabledOkButton = !this.isValid;
    });
  }
  data: DialogModel;
  worksheetPageModel: any;
  onOkClicked(): boolean {
    this.data.input.headers = this.headers.filter(header => header.selected);
    this.data.input.questionnaireName = this.inputForm.controls['questionnaireName'].value;
    this.data.input.tableId = this.tableId;
    return true;
  }
  onOtherButtonClicked?(): boolean {
    this.showGrid = false;
    return false;
  }

  ngOnInit(): void {
    this.workbookSetId = this.data.input.workbookSetId;
    this.workbookId = this.data.input.workbookId;
    this.worksheetId = this.data.input.worksheetId;
    this.workbookName = this.data.input.workbookName;
    this.worksheetName = this.data.input.worksheetName;
    this.questionnaireName = `${this.workbookName}-${this.worksheetName}`;
    this.inputForm.controls['questionnaireName'].setValue(this.questionnaireName);

    // const gridConfig = Configuration.getSmartGridConfig(this.sourceType);
    // gridConfig.Parameters['WORKSHEET_ID'] = this.worksheetId;
    // gridConfig.Parameters['EXECUTION_ID'] = this.worksheetId;

    const query = new PlatformQuery();
    //query.name = 'ExcelTableDefinitionQuery';
    query.api = this.api;
    query.isCamelCase = true;
    query.fieldValues['WorksheetId']  = this.worksheetId;
    this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(response => {
      this.fuseSplashScreenService.hide();
      this.customTypes = response.fieldValues['Types'];
      const headerRow = response.fieldValues['HeaderRow'];
      const startColumn = response.fieldValues['StartColumn'];
      const endColumn = response.fieldValues['EndColumn'];
      const startDataRow = response.fieldValues['StartDataRow'];
      const endDataRow = response.fieldValues['EndDataRow'];
      if (headerRow) {
        this.inputForm.controls['headerRow'].setValue(headerRow);
        this.inputForm.controls['startColumn'].setValue(startColumn);
        this.inputForm.controls['endColumn'].setValue(endColumn);
        this.inputForm.controls['startDataRow'].setValue(startDataRow);
        this.inputForm.controls['endDataRow'].setValue(endDataRow);
      }
      this.worksheetPageModel = this.flexSheetService.getWorksheetPageModel();
      this.totalRowArray = Array.from(Array(this.worksheetPageModel.totalRowCount + 1), (_, x) => x);
      this.totalRowArray.shift();
    });
  }

  onSelectionChanged(event: any) {
    console.log(event);
  }

  apply() {
    const platformCommand = new PlatformCommand('ExtractExcelTableDefinitionCommand', this.api);
    platformCommand.api = this.api;
    platformCommand.fieldValues['WorksheetId'] = this.worksheetId;
    platformCommand.fieldValues['WorkbookId'] = this.workbookId;
    platformCommand.fieldValues['WorkbookSetId'] = this.workbookSetId;
    platformCommand.fieldValues['HeaderRow'] = this.inputForm.controls['headerRow'].value;
    platformCommand.fieldValues['StartColumn'] = this.inputForm.controls['startColumn'].value.name;
    platformCommand.fieldValues['EndColumn'] = this.inputForm.controls['endColumn'].value.name;
    platformCommand.fieldValues['StartDataRow'] = this.inputForm.controls['startDataRow'].value;
    platformCommand.fieldValues['EndDataRow'] = this.inputForm.controls['endDataRow'].value;
    platformCommand.fieldValues['EventSourceId'] = this.workbookSetId;
    platformCommand.fieldValues['DestinationTransportId'] = this.workbookSetId;
    platformCommand.fieldValues['EventSourceApi'] = Api.Spreadsheet;
    platformCommand.fieldValues['IsEventSourceCommand'] = true;
    platformCommand.isCamelCase = true;
    this.commandService.executePlatformCommand(platformCommand).pipe(take(1)).subscribe(response => {
      if (response && response.fieldValues  && response.fieldValues['ExcelTableDefinitionId']) {
        this.tableId = response.fieldValues['ExcelTableDefinitionId'],
        this.parameters = {
          TableId: response.fieldValues['ExcelTableDefinitionId'],
          ServiceName: 'ExcelTableDefinitionDynamicItemService',
          SourceType: this.sourceType,
          IsCompanySpecific: true,
          RootUrlKey: this.api,
          Api: this.api,
          HasVirtualGridConfig: true,
          AllowMultipleCheck: true,
          ShowCheckbox: true,
          ShowCheckAll: true
        };
        this.invalidateSubject.invalidate();
      }

    });
  }

  onGridCellValueChange(event: any) {
    if (event.action) {
      if (event.action.id == 'Edit') {
        event.fieldDefinition.options = this.customTypes;
        this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, '400px', '1500px', 'CustomFieldDefinitionTypes')
        .subscribe(state => {
          console.log('After Edit', state);
          if (state.action === 'OK') {
            this.updateInfo(event.item, event.fieldDefinition);
          }
        });
      } else if (event.action.id == 'Update') {
        const item = event.item;
        this.updateInfo(item, event.fieldDefinition);
      }
    }
  }

  updateInfo(item: any, fieldDefinition: any) {
    const platformCommand = new PlatformCommand('UpdateExcelTableFieldDefinitionCommand', this.api);
    // const value = item.cells[fieldDefinition.key].value;
    const savedItem = item.cells['FieldKey'].value;
    savedItem.header = item.cells['Header'].value;
    savedItem.isPrimaryKey = item.cells['IsPrimaryKey'].value;
    savedItem.isChecked = item.isChecked;
    savedItem.dataType = item.cells['DataType'].value;

    platformCommand.fieldValues['ExcelTableFieldDefinition'] = savedItem;
    // platformCommand.fieldValues['ItemId'] = item.id;
    // platformCommand.fieldValues['WorksheetId'] = this.worksheetId;
    // platformCommand.fieldValues['FieldValue'] = value;
    // platformCommand.fieldValues['FieldKey'] = fieldDefinition.key;
    // platformCommand.isCamelCase = true;
    this.commandService.executePlatformCommand(platformCommand).pipe(take(1)).subscribe(response => {
      this.invalidateSubject.invalidate();
    });
  }
  onFieldSectionChanged(event: any) {

  }

  onSelectionAllChanged($event: any) {
    const platformCommand = new PlatformCommand('UpdateExcelTableCheckStatusCommand', this.api);
    platformCommand.fieldValues['SelectAll'] = $event === 'checked';
    platformCommand.fieldValues['TableId'] = this.tableId;
    this.commandService.executePlatformCommand(platformCommand).pipe(take(1)).subscribe(response => {
      this.invalidateSubject.invalidate();
    });
    this.onSelectionAllChangedInvoked = true;
  }
  onSelectionChange($event: any) {
    // TableId
    // SelectAll
    // CheckedItemIds
    // UncheckedItemIds
    if(this.onSelectionAllChangedInvoked) {
      this.onSelectionAllChangedInvoked = false;
      return;
    }
    const selectedIds = [];
    const unselectedIds = [];
    $event.selectedRows.forEach(o => {
      if (selectedIds.indexOf(o.dataItem.id) === -1) {
        selectedIds.push(o.dataItem.id);
      }
    });
    $event.deselectedRows.forEach(o => {
      const index = selectedIds.indexOf(o.dataItem.id);
      if (index > -1) {
        unselectedIds.push(o.dataItem.id);
        selectedIds.splice(index, 1);
      }
    });
    const platformCommand = new PlatformCommand('UpdateExcelTableCheckStatusCommand', this.api);
    platformCommand.fieldValues['CheckedItemIds'] = selectedIds;
    platformCommand.fieldValues['UncheckedItemIds'] = unselectedIds;
    platformCommand.fieldValues['selectedIds'] = selectedIds;
    platformCommand.fieldValues['TableId'] = this.tableId;
    this.commandService.executePlatformCommand(platformCommand).pipe(take(1)).subscribe(response => {
      this.invalidateSubject.invalidate();
    });
    console.log($event);
  }

}
